import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import TextLink from 'components/TextLink';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
export var PlaylistDropdown = function PlaylistDropdown(_ref) {
  var playlists = _ref.playlists,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(DetailsDropdown, {
    titleKey: "parent_playlist_item_panel_popup_title_colon",
    listItems: playlists.map(function (playlist) {
      return /*#__PURE__*/React.createElement(TextLink, {
        as: NavLink,
        to: "/playlists/".concat(playlist.id),
        bold: true,
        key: playlist.id
      }, playlist.name);
    }),
    listLayout: "stack"
  }, children);
};
export default PlaylistDropdown;